import { getIdealLayoutRecommendation } from '../../../../services/geminiService';

type LayoutCombination = { name: string };

type RunPredictIdealLayoutArgs = {
    layoutProductionByKey: Record<string, number>;
    layoutModulesByKey: Record<string, number>;
    roofCombinationsFromAi: LayoutCombination[];
    setIdealLayoutRecommendation: (next: string | null) => void;
    setIdealLayoutLoading: (next: boolean) => void;
};

export async function runPredictIdealLayoutAction({
    layoutProductionByKey,
    layoutModulesByKey,
    roofCombinationsFromAi,
    setIdealLayoutRecommendation,
    setIdealLayoutLoading,
}: RunPredictIdealLayoutArgs): Promise<void> {
    const apiKey = import.meta.env.VITE_GEMINI_API_KEY;
    if (!apiKey) {
        setIdealLayoutRecommendation('VITE_GEMINI_API_KEY is not set.');
        return;
    }

    const layouts: { name: string; productionW: number; modules: number }[] = [];
    const defaultProd = layoutProductionByKey.default;
    const defaultMods = layoutModulesByKey.default;
    if (typeof defaultProd === 'number' && typeof defaultMods === 'number') {
        layouts.push({ name: 'oneDRAW Default Maxfill', productionW: defaultProd, modules: defaultMods });
    }

    (roofCombinationsFromAi || []).forEach((c) => {
        const prod = layoutProductionByKey[c.name];
        const mods = layoutModulesByKey[c.name];
        if (typeof prod === 'number' && typeof mods === 'number') {
            const displayName = /^(maximum\s+production|max\s+production(\s+with\s+best\s+roofs)?)$/i.test((c.name || '').trim())
                ? 'Max Production with Best Roofs'
                : (c.name || '');
            layouts.push({ name: displayName, productionW: prod, modules: mods });
        }
    });

    if (layouts.length < 2) {
        setIdealLayoutRecommendation('Run AI and wait for layout simulation to complete (at least 2 layout options).');
        return;
    }

    setIdealLayoutLoading(true);
    setIdealLayoutRecommendation(null);
    try {
        const text = await getIdealLayoutRecommendation(apiKey, layouts);
        setIdealLayoutRecommendation(text);
    } catch (e) {
        setIdealLayoutRecommendation(e instanceof Error ? e.message : String(e));
    } finally {
        setIdealLayoutLoading(false);
    }
}
